// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo,
  useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import {Button} from '../../../hola/pub/lib/button';
import Check from '../../../hola/pub/img/hola2023/icons/8/check.svg';
import Arrow_left from '../../../hola/pub/img/hola2023/icons/24/arrow_left.svg';
import Arrow_right from '../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {use_screen} from '../../../hola/pub/lib/screen_util';
import {use_qs_with_set} from '../../../hola/pub/lib/use_qs';
import {use_plans} from './plans/plans';
import {Shared_dc_faq, Dedicated_dc_faq, Isp_plus_faq,
  Smart_resi_faq} from './pricing_faqs';
import {App_context} from 'hola_app_context';
import styles from './pricing_slide.module.less';
import {Need_help_card} from './need_help_card';
import {Other_products} from './toolip/other_products';
import {toolip_zones_availability} from 'hola_opt';

type t_product = 'sdp' | 'ddp' | 'isp' | 'isp_plus' | 'srp';

interface i_pricing_slide_item {
    id: string;
    color: string;
    btn_text: string;
    prod_details: string[];
    include_google?: boolean;
    popular_bg: string;
    popular_color: string;
    with_faq: boolean;
    with_need_help?: boolean;
    with_other_products?: boolean;
    with_isp_toggle?: boolean;
    def_type?: 'isp'|'shared_dc'|'dedicated_dc'|'isp_plus'|'smart_resi';
}

interface i_prices_and_limits_res {
    prices: any[];
    limits: any[];
    unit_prices: any[];
    plan_ids: any[];
    ips_or_gb_amount: any[];
    sold_out?: boolean[];
}

const SHADOWS = {
  'smart_resi': '#E7E5FF87',
  'shared_dc': '#D9EAFF87',
  'dedicated_dc': '#E4DAD087',
  'isp': '#D0D4C287',
  'isp-plus': '#D0D4C287'
};

export const Pricing_slide = (props:i_pricing_slide_item)=>{
    const {theme} = useContext(Settings_context);
    const {user, is_client} = useContext(App_context);
    const [slide, set_slide] = useState(0);
    const [slides_on_screen, set_slides_on_screen] = useState(4);
    const {width} = use_screen();
    const history = useHistory();
    const {qs} = use_qs_with_set();
    const {prod_details, btn_text,
      id, with_faq, with_need_help, with_other_products} = props;
    const period = qs.period;
    const {plans} = use_plans();
    const cards_ref = useRef<HTMLDivElement>();
    const prices_and_limits = useMemo(()=>{
        let product = [];
        if (period)
        {
            if (plans[id].hasOwnProperty(period))
                product = plans[id][period];
        }
        else
            product = plans[id]['1w'] || [];
        if (!product)
            product = [];
        const limits = [];
        const prices = [];
        const unit_prices = [];
        const plan_ids = [];
        const ips_or_gb_amount = [];
        const sold_out = [];
        for (let i = 0; i < product.length; i++)
        {
            const plan = product[i].plan;
            limits.push(`${product[i].limit}`);
            prices.push(plan.price);
            plan_ids.push(plan.id);
            if (product[i]?.ips_amount)
                ips_or_gb_amount.push(product[i].ips_amount);
            else
                ips_or_gb_amount.push(product[i].limit);
            unit_prices.push((plan.price / ips_or_gb_amount[i])
                .toFixed(2) + (id == 'smart_resi' ? ' / GB' : ' / IP'));
            sold_out.push(toolip_zones_availability[id] < ips_or_gb_amount[i]);
        }
        let res: i_prices_and_limits_res = {
            prices,
            limits,
            unit_prices,
            plan_ids,
            ips_or_gb_amount,
        };
        if (sold_out.length > 0)
            res.sold_out = sold_out;
        return res;
    }, [period]);
    const is_all_sold_out = prices_and_limits?.sold_out?.every(v=>v==true);
    const count_ids = prices_and_limits?.plan_ids.length || 4;
    const cards_number = is_all_sold_out || user ? count_ids : count_ids + 1;
    const cards_gap = 32;
    const slide_width = 266;
    const cards_padding = 16;
    const max_slide = cards_number - slides_on_screen;
    const right_btn_v = slide < max_slide;
    const left_btn_v = slide > 0;
    const count_plans_in_row:any = {'--count_plans_in_row': cards_number,
      '--cards_gap': `${cards_gap}px`,
      '--cards_padding': `${cards_padding}px`,
      '--slide': slide,
      '--slide_width': `${slide_width}px`,
      '--carousel_margin_left': `-${slide*slide_width +
        cards_gap*slide - cards_padding / 2}px`,
      '--carousel_width': `${slide_width*slides_on_screen +
        cards_gap*(slides_on_screen -1) - cards_padding / slides_on_screen}px`
    };
    useEffect(()=>{
      set_slide(prev=>prev);
      if (is_client && width < 1023 && slide !== 0)
        set_slide(0);
      if (is_client && width > 1439)
        set_slides_on_screen(4);
      else
        set_slides_on_screen(3);
      if (slide > max_slide)
        set_slide(prev=>prev-1);
    }, [width, slides_on_screen, slide]);
    const card_shadow:any = {'--card_shadow': SHADOWS[id]};
    const card_click = (e, plan_link)=>{
        const closest = s=>e.target?.closest(s);
        if (closest('input') || closest('[class^="but"]') ||
            closest('[class^="toggle"]') || closest('label'))
        {
            return;
        }
        history.push(plan_link);
    };
    const product_id = props.id=='smart_resi' ? 'srp'
    : props.id=='dedicated_dc' ? 'ddp'
    : props.id=='shared_dc' ? 'sdp'
    : props.id as t_product;
    return <div className={styles.container}>
    {is_all_sold_out && <div className={styles.all_sold_out}>
      <p className={cn(theme.mono16, theme.color_n700)}>All Sold Out!</p>
    </div>}
    <div className={cn(styles.cards_wrapper)}>
      {!left_btn_v &&
        <div className={cn(styles.prev_hidden, styles.prev)}>&nbsp;</div>}
      {left_btn_v &&
        <button className={styles.prev} onClick={()=>set_slide(prev=>prev-1)}>
          <Arrow_left /> </button>}
      <div className={styles.cards_v3} ref={cards_ref}
        style={count_plans_in_row}>
        <div className={styles.carousel}>
          {Array.from({length: cards_number}).map((_, i)=>{
            const is_sold_out = is_all_sold_out ? true
              : cards_number == count_ids + 1 ?
              prices_and_limits?.sold_out?.[i-1] :
              prices_and_limits?.sold_out?.[i];
            let p_i = is_all_sold_out ? i : !user ? i-1 : i;
            let is_free = !user && i === 0 && !is_sold_out;
            const plan_link = is_free ? '/dashboard' :
              `/pricing/checkout?plan_id=${prices_and_limits?.plan_ids[p_i]}`;
            const with_most_popular = !user && i==3;
            const btn_color = with_most_popular ? 'black' :
              'transparent_black';
            return <Fragment key={`${id}_${i}`}>
              <div className={styles.card_container}
                onClick={e=>is_sold_out ? null : card_click(e, plan_link)}>
                  <div className={cn(styles.card_v2, is_sold_out ?
                    styles.sold_out_card : is_free ?
                    styles.free : styles[id])} style={card_shadow}>
                    <div className={cn(styles.card_v2_header, is_sold_out ?
                      styles.sold_out : is_free ? styles.free : styles[id])}>
                      <p className={cn(theme.p16, theme.med, is_sold_out ?
                        theme.color_n300 : theme.color_n700)}>
                        {!is_free && prices_and_limits?.ips_or_gb_amount[p_i]}
                        {is_free ? 'FREE' : id == 'smart_resi' ? ' GB' :
                          prices_and_limits?.ips_or_gb_amount[p_i] == 1
                            ? ' proxy' : ' proxies'}
                      </p>
                      {is_free && <div className={cn(theme.mono14,
                        styles.card_v2_free, theme.reg, theme.color_n500)}>
                        3 day plan
                        </div>}
                      {is_sold_out && !is_all_sold_out && <div
                        className={cn(styles.sold_out_badge)}>
                      <p className={cn(theme.mono14, theme.med,
                        is_sold_out ? theme.color_n700 :
                        styles[`popular_${id}`])}>
                        Sold Out!
                      </p>
                    </div>}
                      {!is_sold_out && with_most_popular && <div
                        className={cn(styles.most_popular_v2,
                        styles.most_popular_v3)}>
                      <p className={cn(theme.mono14, theme.reg,
                        styles[`popular_${id}`])}>
                        Popular !
                      </p>
                    </div>}
                    </div>
                  <div className={is_free ? cn(styles.card_v2_body,
                    styles.card_v2_body_free) : styles.card_v2_body}>
                    <p className={cn(theme.med, theme.p24, is_sold_out ?
                      theme.color_n300 : theme.color_n700)}>
                      ${is_free ? '0' : prices_and_limits?.unit_prices[p_i]}
                    </p>
                    <p className={cn(theme.p14, theme.reg, is_sold_out ?
                      theme.color_n300 : theme.color_n500)}>
                      {is_free ? 'No credit card required!' :
                      `$${prices_and_limits?.prices[p_i]} billed`}
                    </p></div>
                    <hr className={cn(styles.hr, is_sold_out ?
                      styles.sold_out_hr :
                      is_free ? styles.free : styles[id])}/>
                    <div className={styles.card_v2_bottom}>
                    <div className={styles.card_v2_content}>
                      {is_free ? <p className={cn(theme.p14, theme.reg,
                      theme.color_n500, styles.restrictions, styles.free)}>
                          <span>Up to</span> <b>100MB </b>
                          <span>Bandwidth</span>
                        </p>
                      : id == 'smart_resi' ?<p className={cn(theme.p14,
                        theme.reg, theme.color_n500,
                        styles.restrictions, styles[id])}>
                        <b>Unlimited</b> <span>sessions</span>
                      </p> :
                      id != 'smart_resi' && !id.includes('isp') &&
                      <p className={cn(theme.p14, theme.reg, theme.color_n500,
                        styles.restrictions, styles[id])}>
                        Up to{' '}
                        <span className={cn(theme.med, theme.p16)}>
                          {prices_and_limits?.limits[p_i]}GB{' '}
                        </span>
                        Bandwidth
                      </p>}
                      {!is_free && id.includes('isp') &&
                      <p className={cn(theme.p14, theme.reg, is_sold_out ?
                        theme.color_n300 : theme.color_n700,
                        styles.restrictions, is_sold_out ?
                        styles.sold_out : styles[id])}>
                        Unlimited
                        <span> Bandwidth</span>
                      </p>}
                    </div>
                    {!is_sold_out ?
                    <div className={cn(styles.card_v3_btn,
                      styles.card_v2_btn)}>
                      <Button w100={true}
                        caption={is_free ? 'Try for free' : btn_text}
                        round={false} color={btn_color}
                        to={is_free ? '/dashboard' :
                          `/pricing/checkout?plan_id=`+
                          `${prices_and_limits?.plan_ids[p_i]}`}/>
                    </div> :
                    <div className={styles.card_v2_btn}>
                    <Button w100={true} caption={btn_text} round={false}
                      color={'transparent_black'} cls={styles.sold_out_btn}/>
                  </div>}
                  </div>
                  </div>
              </div>
            </Fragment>;
          })}
        </div>
      </div>
      {!right_btn_v || is_all_sold_out &&
        <div className={cn(styles.prev_hidden, styles.prev)}>&nbsp;</div>}
      {right_btn_v && !is_all_sold_out&&
        <button className={styles.next} onClick={()=>set_slide(prev=>prev+1)}>
        <Arrow_right /></button>}
    </div>
    <div className={cn(styles.details, styles.details_v2)}>
        {prod_details.map(detail=>
      <span className={styles.detail} key={`${id}_${detail}`}>
        <div className={styles.circle}>
          <Check/>
        </div>
        <p className={theme.p3}>{detail}</p>
      </span>
    )}</div>
    {with_need_help && is_client && width > 1280 && <Need_help_card/>}
    {with_other_products && is_client && width > 1280 &&
     <Other_products prod={product_id}/>}
    {with_faq && <div className={styles.faq_container}>
      <p className={cn(theme.p22, theme.med, theme.color_n700,
        styles.faq_title)}>FAQs</p>
      {id == 'shared_dc' && <Shared_dc_faq/>}
      {id == 'dedicated_dc' && <Dedicated_dc_faq/>}
      {(id == 'isp_plus' || id == 'isp') && <Isp_plus_faq/>}
      {id == 'smart_resi' && <Smart_resi_faq/>}
    </div>}
  </div>;
};
